import Trans from 'next-translate/Trans'

import Link from '@/atoms/Link'
import { TransHeadingProps } from '@/views/product/ts'

function TransHeading({ nickname, slug }: TransHeadingProps) {
  return (
    <Trans
      i18nKey="products:other_products_from"
      components={[
        <></>,
        <Link
          className="transition-colors duration-300 hover:text-violet-120"
          key={slug}
          href={`/creators/${slug}`}
        >
          a
        </Link>,
      ]}
      values={{ nickname }}
    />
  )
}

export default TransHeading
